import React from 'react'
import { GlobalOutlined, SearchOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { AntdTableEmptyPlaceholder } from '@pushly/aqe/lib/components'

/** What a table of domains says when the search has left nothing; the action puts every domain back. */
export const NoDomainsMatchSearch: React.FC<{ searchTerm: string; onClearSearch: () => void }> = ({
    searchTerm,
    onClearSearch,
}) => (
    <AntdTableEmptyPlaceholder
        icon={<SearchOutlined />}
        text="No domains match"
        description={`Nothing matches "${searchTerm}". Try part of a domain's name or hostname.`}
        action={<Button onClick={onClearSearch}>Clear search</Button>}
    />
)

/** What a table of domains says when the filter holds no domain at all. */
export const NoDomains: React.FC = () => (
    <AntdTableEmptyPlaceholder
        icon={<GlobalOutlined />}
        text="No domains"
        description="This organization has no domains to report on yet."
    />
)
